/* @flow */

import { api } from '../infrastructure/api'

export default api
